export const CONSTANTS_PREBUILD_CAMPAIGNS = {
    CAMPAIGNS: [
      {
        id: 1,
        category: 'Demographics',
        key: 'ENTIRE_DATABASE',
        name: 'Entire Database (Prospects, active & ex member)',
        description: 'Campaign targeting all database users including prospects, active and ex members',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1 OR client_status = :client_status_2 OR client_status = :client_status_3 OR client_status = :client_status_4 OR client_status = :client_status_5 OR client_status = :client_status_6 OR client_status = :client_status_7)\",\"params\":{\"client_status_1\":1,\"client_status_2\":2,\"client_status_3\":3,\"client_status_4\":4,\"client_status_5\":5,\"client_status_6\":6,\"client_status_7\":7}}"
      },
      {
        id: 2,
        category: 'Demographics',
        key: 'FEMALES_PROSPECT',
        name: 'All Females (Prospect)',
        description: 'Campaign targeting all female prospects',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1 AND client_gender IN (:client_gender_1))\",\"params\":{\"client_gender_1\":1,\"client_status_1\":1}}"
      },
      {
        id: 3,
        category: 'Demographics',
        key: 'MALES_PROSPECT',
        name: 'All Males (Prospect)',
        description: 'Campaign targeting all male prospects',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_gender IN (:client_gender_1) AND client_status = :client_status_1)\",\"params\":{\"client_gender_1\":2,\"client_status_1\":1}}"
      },
      {
        id: 4,
        category: 'Demographics',
        key: 'FEMALES_ACTIVE',
        name: 'All Females (Active Member)',
        description: 'Campaign targeting all female active members',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_gender IN (:client_gender_1) AND client_status = :client_status_1)\",\"params\":{\"client_gender_1\":1,\"client_status_1\":3}}"
      },
      {
        id: 5,
        category: 'Demographics',
        key: 'MALES_ACTIVE',
        name: 'All Males (Active Member)',
        description: 'Campaign targeting all male active members',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_gender IN (:client_gender_1) AND client_status = :client_status_1)\",\"params\":{\"client_gender_1\":2,\"client_status_1\":3}}"
      },
      {
        id: 6,
        category: 'Demographics',
        key: 'FEMALES_ALL',
        name: 'All Females (Entire Database)',
        description: 'Campaign targeting all females in the database',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_gender IN (:client_gender_1) AND (client_status = :client_status_1 OR client_status = :client_status_2 OR client_status = :client_status_3 OR client_status = :client_status_4 OR client_status = :client_status_5 OR client_status = :client_status_6 OR client_status = :client_status_7))\",\"params\":{\"client_gender_1\":1,\"client_status_1\":1,\"client_status_2\":2,\"client_status_3\":3,\"client_status_4\":4,\"client_status_5\":5,\"client_status_6\":6,\"client_status_7\":7}}"
      },
      {
        id: 7,
        category: 'Demographics',
        key: 'MALES_ALL',
        name: 'All Males (Entire Database)',
        description: 'Campaign targeting all males in the database',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_gender IN (:client_gender_1) AND (client_status = :client_status_1 OR client_status = :client_status_2 OR client_status = :client_status_3 OR client_status = :client_status_4 OR client_status = :client_status_5 OR client_status = :client_status_6 OR client_status = :client_status_7))\",\"params\":{\"client_gender_1\":2,\"client_status_1\":1,\"client_status_2\":2,\"client_status_3\":3,\"client_status_4\":4,\"client_status_5\":5,\"client_status_6\":6,\"client_status_7\":7}}"
      },
      {
        id: 8,
        category: 'Membership Status',
        key: 'ALL_PROSPECTS',
        name: 'All Prospects',
        description: 'Campaign targeting all prospects',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1)\",\"params\":{\"client_status_1\":1}}"
      },
      {
        id: 9,
        category: 'Membership Status',
        key: 'ALL_ACTIVE_MEMBERS',
        name: 'All Active Members',
        description: 'Campaign targeting all active members',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1 OR client_status = :client_status_2)\",\"params\":{\"client_status_1\":3,\"client_status_2\":4}}"
      },
      {
        id: 10,
        category: 'Membership Status',
        key: 'ALL_EX_MEMBERS',
        name: 'All Ex members',
        description: 'Campaign targeting all ex-members',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1 OR client_status = :client_status_2)\",\"params\":{\"client_status_1\":5,\"client_status_2\":6}}"
      },
      {
        id: 11,
        category: 'Membership Status',
        key: 'ACTIVE_WITHOUT_PT',
        name: 'Active members without PT',
        description: 'Campaign targeting active members without personal training',
        status: 'pending',
        sql_rule: "{\"sql\":\"(client_status = :client_status_1 OR client_status = :client_status_2 OR (membership_servicecategory != :membership_servicecategory_1 AND membership_enddate > :membership_enddate_1))\",\"params\":{\"client_status_1\":3,\"client_status_2\":4,\"membership_enddate_1\":\"2025-04-01\",\"membership_servicecategory_1\":126}}",
      },
      {
        id: 12,
        category: 'Membership Status',
        key: 'EX_MEMBERS_90_DAYS',
        name: 'All Ex Member older 90 days',
        description: 'Campaign targeting ex-members who left more than 90 days ago',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_churndate <= :client_churndate_1 AND (client_status = :client_status_1 OR client_status = :client_status_2))\",\"params\":{\"client_status_1\":5,\"client_status_2\":7,\"client_churndate_1\":\"2024-12-31\"}}",
      },
      {
        id: 13,
        category: 'Special Groups',
        key: 'HIGH_SPENDERS',
        name: 'High Spenders',
        description: 'Campaign targeting members with high spending patterns',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_lifetimevalue > :client_lifetimevalue_1)\",\"params\":{\"client_lifetimevalue_1\":50000}}",
      },
      {
        id: 14,
        category: 'Special Groups',
        key: 'BIRTHDAY_MONTH',
        name: 'Birthday Month',
        description: 'Campaign targeting members with birthdays in the current month',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_dob >= :client_dob_1 AND client_dob <= :client_dob_2)\",\"params\":{\"client_dob_1\":\"2025-04-01\",\"client_dob_2\":\"2025-04-30\"}}",
      },
      {
        id: 15,
        category: 'Special Groups',
        key: 'AT_RISK_ALL',
        name: 'At Risk (All)',
        description: 'Campaign targeting all members identified as at risk',
        status: 'active',
        sql_rule: "{\"sql\":\"(client_isatrisk = :client_isatrisk_1)\",\"params\":{\"client_isatrisk_1\":1}}",
      },
    ],
  };
  
  